export default __webpack_public_path__ + "static/media/pinky_ladyyyyy.3d337e78.jpg";